import _ from 'lodash'
import { currency } from "../../../common/services/common.service";

export default function VehicleCard({ vehicle, handleEstimate }: any) {
    return (
        <div className="bg-white w-64 shadow-md rounded-lg overflow-hidden mb-8">
            {/* Vehicle Name */}
            <h3 className="text-xl text-gray-900 font-semibold text-center p-4">
                {vehicle?.VehicleType}
            </h3>

            {/* Image or SVG Placeholder */}
            <div className="flex items-center justify-center w-full h-36 bg-white-100 p-3">
                {vehicle?.MediaMappings?.MediaFiles?.length > 0 ? (
                    <img
                        src={vehicle?.MediaMappings?.MediaFiles[0]?.FileMappingURL}
                        alt="Vehicle"
                        className="w-36 h-36 object-cover"
                    />
                ) : (
                    <svg fill="#000000" height="120px" width="120px" viewBox="0 0 512 512">
                        <g>
                            <g>
                                <path d="M106.846,320c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2s51.2-22.963,51.2-51.2 C158.046,342.963,135.074,320,106.846,320z M106.846,405.333c-18.825,0-34.133-15.309-34.133-34.133s15.309-34.133,34.133-34.133 s34.133,15.309,34.133,34.133S125.662,405.333,106.846,405.333z"></path>
                            </g>
                        </g>
                    </svg>
                )}
            </div>

            {/* Vehicle Details */}
            <div className="p-4 text-center">
                <p className="text-sm text-gray-600">Vehicle Weight: {vehicle?.VehicleWeight}</p>
                <p className="text-sm text-gray-600">Capacity: Up to {vehicle?.LoadingCapacity} Kg</p>
            </div>

            {/* Pricing */}
            {/* <div className="p-4 text-center">
          <p className="text-2xl font-semibold text-gray-700">{currency(vehicle?.Price)}</p>
        </div> */}

            {/* Know More Button */}
            <div className="p-4 text-center">
                <button
                    onClick={() => handleEstimate(vehicle)}
                    className="px-4 py-2 text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-200 transition duration-200"
                >
                    Know More
                </button>
            </div>
        </div>



    );
}
